const resizeImage = function(url, { width = 0, height = 0, limit = 1 }) {
  if (url == null || url === '') {
    return url
  }
  return `${url}?x-oss-process=image/resize,m_fill,h_${height},w_${width},limit_${limit}`
}

const square = function(url, size) {
  return resizeImage(url, { width: size, height: size })
}

const s100 = function(url) {
  return square(url, 100)
}

const s200 = function(url) {
  return square(url, 200)
}

const s400 = function(url) {
  return square(url, 400)
}

export default { resizeImage, square, s100, s200, s400 }

